module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "alert alert-info widget-block"
  }, [_c('div', {
    staticClass: "widget-filter-ticket-label-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleChoiceBlock($event)
      }
    }
  }, [(_vm.curValue === undefined || _vm.curValue === null || _vm.curValue === '' || _vm.curValue === false) ? [_vm._v(_vm._s(_vm._f("ftc")('main/list_all')))] : _c('div', {
    staticClass: "w5-list-ticket-label",
    class: 'ticket-label-color-' + String(_vm.curValue).toLowerCase(),
    staticStyle: {
      "margin-top": "5px",
      "margin-left": "1px"
    }
  })], 2)]), _vm._v(" "), (_vm.items && typeof _vm.items === 'object' && Object.keys(_vm.items).length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoice === true),
      expression: "showChoice === true"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideChoiceBlock),
      expression: "hideChoiceBlock"
    }],
    staticClass: "widget-filter-ticket-label-choice",
    staticStyle: {
      "top": "4px",
      "left": "10px"
    }
  }, [_vm._l((_vm.items), function(val, idx) {
    return (String(val) !== '') ? _c('div', {
      staticClass: "w5-list-ticket-label cursor-pointer",
      class: 'ticket-label-color-' + String(val).toLowerCase(),
      on: {
        "click": function($event) {
          return _vm.onClick($event, val)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.curValue !== undefined && _vm.curValue !== null && _vm.curValue !== '' && _vm.curValue !== false) ? _c('span', {
    staticClass: "ticket-label-all",
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_all')))]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f98fbcba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/filterLabel.vue
// module id = 491
// module chunks = 0